<template>
  <CommonLayout header="floristHeader" footer="floristFooter">
    <MeetingLayout :type="this.consts.meetingType.florist">
      <div class="base-color h-100 mh-550 shadow">
        <div class="p-2 h-100">
          <div class="text-center">
            <h4 class="pt-3">Best Wishes on Your Wedding.</h4>
            <p class="pt-3" style="white-space:break-spaces; font-size:larger">お打ち合わせいただきありがとうございました
おふたりのフラワーコーディネートが素敵になりますよう
精一杯ご準備させていただきます
当日までどうぞよろしくお願いいたします
            </p>
          </div>

          <div><img class="w-100" :src="imageUrl"></div>

          <div class="text-right position-absolute fixed-bottom mb-3 mr-5">
            <b-button variant="outline-primary" class="w-25 sub-button-color" @click="prevPage">戻る</b-button>
            <b-button :variant="ishangUpDisabled ? 'primary' : 'outline-primary'" class="w-25 ml-3" :class="ishangUpDisabled ? 'disabled-button-color' : 'sub-button-color'" :disabled="ishangUpDisabled" @click="hangUp">接続終了</b-button>
          </div>
        </div>
      </div>
    </MeetingLayout>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import SignalingModel from '@/models/SignalingModel'
import mstore from '@/store/meeting-store'
import logoff from '@/mixins/logoff'

export default {
  name: 'FloristMeetingFinish',
  components: { CommonLayout, MeetingLayout, CommonModal },
  computed: {
    getIsTargetAtendeeActive () {
      // カスタマーとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    }
  },
  data () {
    return {
      // 通話終了ボタン活性制御
      ishangUpDisabled: false,
      imageUrl: ''
    }
  },
  methods: {
    // 戻る
    prevPage () {
      const targetPath = '/florist/meeting/estimate'
      SignalingModel.sendClickEvent('prev', this, {'target_path': targetPath.replace('florist', 'customer')})
      this.$router.push(targetPath)
    },
    // 通話終了
    hangUp: async function () {
      sessionStorage.setItem('noDisplayMessageFlag', 'true')
      this.ishangUpDisabled = true
      await SignalingModel.sendClickEvent('hangUp', this)

      if (logoff.logoff_kyoutu()) {
        sessionStorage.removeItem('meeting')
        sessionStorage.removeItem('attendee')
        sessionStorage.removeItem('myselfTileId')
        sessionStorage.removeItem('yourselfTileId')
        sessionStorage.removeItem('guest1TileId')
        sessionStorage.removeItem('guest2TileId')
        sessionStorage.removeItem('guest3TileId')
        sessionStorage.removeItem('hideMySelfVideo')
        sessionStorage.removeItem('hideYourSelfVideo')
        sessionStorage.removeItem('hideGuest1SelfVideo')
        sessionStorage.removeItem('hideGuest2SelfVideo')
        sessionStorage.removeItem('hideGuest3SelfVideo')
      }

      return false
    }
  },
  mounted () {
    // sessionStorageの最終遷移ページ・操作件を削除
    sessionStorage.removeItem('lastRoutePath')
    sessionStorage.removeItem('floristIsOperationPossible')
    this.imageUrl = this.config.imageURL + '/meeting-contents/mtg-finish.jpg'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/FloristMeetingFinish.vue